<template>
  <div
    :class="{
      'nvr-box': true,
      'nvr-box-large': scale < 1.6 ? true : false,
      'nvr-box-tiny': scale >= 1.6 ? true : false,
    }"
    :style="{ width: cvrWidth }"
  >
    <div class="nvr-player">
      <div class="player_title"></div>
      <div id="divPlugin" class="plugin" :style="{ width: cvrWidth, height: cvrHeight }">
        <video
          v-if="isVideo"
          id="myPlayer"
          ref="myPlayer"
          class="centeredVideo"
          controls
          muted
        >
          Your browser is too old which doesn't support HTML5 video.
        </video>
        <video
          v-else-if="!isVideo && !isAll"
          id="recoderVideoOther"
          class="centeredVideo"
          x5-video-player-typ="h5"
          x-webkit-airplay="true"
          x5-video-player-fullscreen="true"
          preload="auto"
          playsinline="true"
          webkit-playsinline
          muted
        ></video>
      </div>
      <!-- <div v-if="!isVideo" class="recoder-bar" :style="{'left': isAll || isScale ? '0' : '-91.5%'}">
        <div class="recoders" v-for="(item, i) in recoderList" :key="i"></div>
        <div ref="sliderBar" class="block" style="width: 100%">
          <el-slider
            @change="recordChange()"
            v-model="curRecodeTime"
            :format-tooltip="formatTooltip"
          ></el-slider>
        </div>
      </div>
      <div v-if="!isVideo" class="hour-bar" :style="{'left': isAll || isScale ? '0' : '-91.5%'}">
        <div
          class="hour-item"
          v-for="(item, n) in hourList"
          v-bind:key="'hour-' + n"
        >
          {{ item }}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import flvjs from "flv-h265.js";
import axios from "axios";
import { unref } from "vue";
const url = "/api/v1/login?username=easycvr&password=5cdecdb8e87a0db1fe6e35555a870ae5";
export default {
  name: "VdmCvr",
  props: ["cvrHeight", "cvrWidth"],
  inject: ["getVideoClose", "updateVideoType"],
  computed: {
    ...mapState({ dialog: (state) => state.dialog }),
    ...mapState({ app: (state) => state.app }),
    ...mapGetters(["dialogVisible"]),
  },
  watch: {
    nvrIp: {
      handler(n) {
        console.log(n, "XXXXXXXXXXXXXXXXXX");
        if (this.nvrIp) {
          this.getEasyCvrList(this.renderVideo);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      videoBaseUrl: bmeConfig.easyNvrUrl, //工厂本地地址
      easyNvrProtocol: bmeConfig.easyNvrProtocol,
      recordeId: "",
      deviceId: "",
      token: "", // 摄像头token
      scale: 1,
      iChannelId: 1,
      curRecodeTime: 0,
      isVideo: false,
      recoderVideo: null,
      recorderTimer: null,
      keepRecoderAliveTimer: null,
      hls: null,
      recoderList: [],
      hourList: [
        "00:00",
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
      ],
      videoInfo: {},
      channelsObj: {},
      channelsIds: {},
      channelItems: [],
      selTimeStamp: "",
    };
  },
  methods: {
    ...mapActions(["setDialog"]),
    getData(data) {
      console.log(data);
      this.getEasyCvrList(this.renderVideo);
      this.nvrIp = data.ip;
      this.lastTime = data.startTime;
      this.recodeDate = data.startTime;
      this.channelId = data.channel;
    },
    date_change() {
      let that = this;
      let ts = new Date().getTime();
      let curDailyObj = new Date(that.recodeDate ? that.recodeDate : that.lastTime);
      //   console.log(curDailyObj, that.recodeDate, that.lastTime, "curDailyObj");
      let curDaily =
        curDailyObj.getFullYear() +
        that.convertDoubleNum(curDailyObj.getMonth() + 1) +
        that.convertDoubleNum(curDailyObj.getDate());
      let getUrl =
        "/api/v1/record/querydaily?id=" +
        that.recordeId +
        "&recordType=Device" +
        "&period=" +
        curDaily +
        "&_=" +
        ts +
        "&token=" +
        that.token;
      $.ajax({
        url: getUrl,
        success(res) {
          that.recoderList = [];
          let tmpList = res.list;
          tmpList.forEach((item) => {
            let stStr =
              item.startAt.substr(0, 4) +
              "/" +
              item.startAt.substr(4, 2) +
              "/" +
              item.startAt.substr(6, 2) +
              " " +
              item.startAt.substr(8, 2) +
              ":" +
              item.startAt.substr(10, 2) +
              ":" +
              item.startAt.substr(12, 2);
            let strB =
              item.startAt.substr(0, 4) +
              "/" +
              item.startAt.substr(4, 2) +
              "/" +
              item.startAt.substr(6, 2) +
              " 00:00:00";
            let strE =
              item.startAt.substr(0, 4) +
              "/" +
              item.startAt.substr(4, 2) +
              "/" +
              item.startAt.substr(6, 2) +
              " 23:59:59";
            let st = new Date(stStr).getTime();
            let delta = st - new Date(strB).getTime();
            let delta_ = new Date(strE).getTime() - new Date(strB).getTime();
            let l = Math.floor((delta / delta_) * 1440);
            let w = Math.floor(((item.duration * 1000) / delta_) * 1440) - 2;
            that.recoderList.push({
              l: l,
              w: w,
              hls: item.hls,
              b: st,
              s: item.startAt,
              duration: item.duration,
              name: item.name,
              startAt: item.startAt,
            });
          });
          that.recordChange(1);
        },
      });
    },
    // 获取通道视频信息封装videlInfo
    getEasyCvrList(cb) {
      axios
        .get(url, {})
        .then((res) => {
          this.token = res.data.EasyDarwin.Body.Token;
          let getUrl = bmeConfig.cvrNewApi
            ? "/api/v1/devicesconfig?start=0&limit=9999"
            : "/api/v1/devices?start=0&limit=9999";
          this.channelsObj = {};
          this.channelsIds = {};
          axios
            .get(getUrl, {
              params: { token: this.token },
            })
            .then((res) => {
              if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                let devices = res.data.EasyDarwin.Body.Devices;
                devices.forEach((item, i) => {
                  let tmpDeviceIp = item.DeviceIp ? item.DeviceIp : item.DeviceName;
                  let tmpChannels = item.channels;
                  this.channelItems.push(tmpChannels);
                  this.channelItems[i].forEach((x1) => {
                    x1.deviceIp = tmpDeviceIp;
                  });
                  //   console.log(this.channelItems);
                  if (
                    devices[i]["DeviceIp"] === this.nvrIp ||
                    devices[i]["DeviceName"] === this.nvrIp
                  ) {
                    this.deviceId = devices[i]["DeviceID"];
                    // console.log(this.deviceId, "deviceId");
                  }
                  tmpChannels.forEach((item_) => {
                    let tmpChannelID = item_.Name;
                    this.channelsObj[tmpDeviceIp + "_" + tmpChannelID] = item_.SnapUrl;
                    this.channelsIds[tmpDeviceIp + "_" + tmpChannelID] = item_.ChannelID;
                  });
                });
                if (cb) {
                  cb();
                }
              }
            })
            .catch((err) => {
              console.error(err);
              if (cb) {
                cb();
              }
            });
        })
        .catch((err) => {
          console.error(err);
          if (cb) {
            cb();
          }
        });
    },
    getCameraClassify() {
      //   console.log(this.channelsIds, this.channelsObj, "channels");
      return new Promise((resolve, reject) => {
        let findVideoMonitoringUrl =
          CONFIG.requestName + this.$apiOpt.findVideoMonitoring;
        this.$apiUtils
          .get(findVideoMonitoringUrl, {
            customerId: this.$store.state.customerId,
            isMore: true,
          })
          .then((data) => {
            data &&
              data.forEach((x1, i1) => {
                x1.list.forEach((x2, i2) => {
                  if (!x2.nvrIp && bmeConfig.useAddressIP) {
                    x2.nvrIp = x2.ipAddress;
                  }
                  if (!x2.channelId && bmeConfig.HKchannelId) {
                    x2.channelId = bmeConfig.HKchannelId;
                  }
                });
              });
            if (this.channelsObj) {
              data &&
                data.forEach((x1, i1) => {
                  x1.list.forEach((x2, i2) => {
                    if (
                      x2.cameraType === "newEasyNvr" ||
                      bmeConfig.isEasyNvr ||
                      bmeConfig.isEasyCvr
                    ) {
                      x2["picUrl"] = this.channelsObj
                        ? this.channelsObj[x2.ipAddress]
                          ? this.videoBaseUrl + this.channelsObj[x2.ipAddress]
                          : this.videoBaseUrl +
                            this.channelsObj[x2.nvrIp + "_" + x2.channelId]
                        : "";
                      x2["recordeId"] = this.channelsIds[x2.nvrIp + "_" + x2.channelId];
                    }
                  });
                });
            }
            resolve(data);
          });
      });
    },
    async renderVideo() {
      let videoList = await this.getCameraClassify();
      //   console.log(videoList, "videoList");
      let tmp;
      videoList.forEach((item) => {
        item.list.forEach((it) => {
          if (it.ipAddress === this.nvrIp && it.channelId === this.channelId) {
            this.videoBaseUrl = bmeConfig.easyNvrUrl;
            this.easyNvrProtocol = bmeConfig.easyNvrProtocol;
            this.iChannelId = it.channelId;
            this.szIP = it.nvrIp;
            this.username = it.nvrUsername;
            this.password = it.nvrPassword;
            this.ipAddress = it.ipAddress;
          }
        });
      });
      this.channelItems.forEach((channel) => {
        channel.forEach((item) => {
          //   console.log(item);
          if (item.deviceIp === this.nvrIp && item.Name == this.channelId) {
            this.recordeId = item.ChannelID;
          }
        });
      });

      console.log(this.recordeId, this.nvrIp, "tmp");
      this.date_change();
    },
    recordChange(curRecodeTime) {
      if (curRecodeTime) this.curRecodeTime = curRecodeTime;
      this.record_destroy();
      let curTimeObj = new Date(this.recodeDate ? this.recodeDate : this.lastTime);
      let curYear = curTimeObj.getFullYear();
      let curMonth = curTimeObj.getMonth() + 1;
      let curDate = curTimeObj.getDate();
      let curTime = new Date(`${curYear}/${curMonth}/${curDate} 00:00:00`).getTime();
      curTime = curTime + parseInt((this.curRecodeTime / 100) * 24 * 3600 * 1000);
      let timeObj = new Date(curTime);
      let selTime = null,
        tmpObj = null;
      if (this.recoderList[this.recoderList.length - 1]["b"] < curTime) {
        selTime = this.recoderList[this.recoderList.length - 1]["s"];
        tmpObj = this.recoderList[this.recoderList.length - 1];
      } else {
        for (let i = 0; i < this.recoderList.length; i++) {
          if (
            this.recoderList[i]["b"] <= curTime &&
            this.recoderList[i + 1]["b"] > curTime
          ) {
            selTime = this.recoderList[i]["s"];
            tmpObj = this.recoderList[i];
            break;
          }
        }
      }
      if (selTime && tmpObj) {
        let selTimeFormat =
          selTime.substr(0, 4) +
          "/" +
          selTime.substr(4, 2) +
          "/" +
          selTime.substr(6, 2) +
          " " +
          selTime.substr(8, 2) +
          ":" +
          selTime.substr(10, 2) +
          ":" +
          selTime.substr(12, 2);
        let deltaSecond = timeObj.getTime() - new Date(selTimeFormat).getTime();
        let eTstemp = new Date(
          // new Date(selTimeFormat).getTime() + tmpObj["duration"] * 1000
          new Date(selTimeFormat).getTime() + 1000 * 60
        );
        let endTime =
          eTstemp.getFullYear() +
          "" +
          this.convertDoubleNum(eTstemp.getMonth() + 1) +
          "" +
          this.convertDoubleNum(eTstemp.getDate()) +
          "" +
          this.convertDoubleNum(eTstemp.getHours()) +
          "" +
          this.convertDoubleNum(eTstemp.getMinutes()) +
          "" +
          this.convertDoubleNum(eTstemp.getSeconds());
        // console.log(selTime, endTime, "selTime");
        //http://localhost:18000/api/v1/devices/record/playback?file=ch0001_04010000663000000&duration=2240&stime=20210904114432&etime=20210904122152&channel=1&protocol=flv
        let tmpArgs = `file=${tmpObj["name"]}&duration=${tmpObj["duration"]}&stime=${selTime}&etime=${endTime}&channel=${this.recordeId}&protocol=flv`;
        let getUrl = this.videoBaseUrl + "/api/v1/devices/record/playback?" + tmpArgs;
        axios
          .get(getUrl, {
            params: { token: this.token },
          })
          .then((res) => {
            if (res.data.EasyDarwin.Header.ErrorNum == 200) {
              let recorderUrl = res.data.EasyDarwin.Body.URL;
              this.initRecode(recorderUrl, tmpArgs, deltaSecond);
            }
          })
          .catch((err) => console.error(err));
      }
    },
    initRecode(url, args, deltaSec) {
      this.recorderUrl = url;
      let recoderVideo = this.isAll
        ? document.getElementById("recoderVideo")
        : document.getElementById("recoderVideoOther");
      if (flvjs.isSupported()) {
        let videoBaseUrl = this.videoBaseUrl;
        if (this.easyNvrProtocol === "WS-FLV") {
          videoBaseUrl = videoBaseUrl.replace(/http:\/\//g, "ws://");
        }
        this.recoderVideo = flvjs.createPlayer({
          type: "flv",
          isLive: true,
          url: videoBaseUrl + url,
          duration: 0,
        });
        this.recoderVideo.attachMediaElement(recoderVideo);
        this.recoderVideo.load();
        if (deltaSec && deltaSec > 0) {
          this.recoderVideo.onloademetadata = () => {
            // console.log(this.recoderVideo.duration);
            this.recoderVideo.currentTime = parseInt(deltaSec / 1000);
          };
        }
        this.recoderVideo.play();
        if (this.recorderTimer) {
          clearInterval(this.recorderTimer);
        }
        this.recorderTimer = setInterval(() => {
          if (!this.recoderVideo.buffered.length) {
            return;
          }
          let end = this.recoderVideo.buffered.end(0);
          let diff = end - this.recoderVideo.currentTime;
          if (diff >= 1.5) {
            this.recoderVideo.currentTime = end - 0.1;
          }
        }, 3 * 10 * 1000);
        if (window.keepRecoderAliveTimer) {
          clearTimeout(window.keepRecoderAliveTimer);
        }
        window.keepRecoderAliveTimer = setTimeout(() => {
          this.keepRecoderAlive(url, args);
        }, 30 * 1000);
      }
    },
    keepRecoderAlive(url, args) {
      let getUrl = "/api/v1/devices/record/playback?" + args + "&url=" + url;
      axios.get(getUrl, {
        params: { token: this.token },
      });
      if (window.keepRecoderAliveTimer) {
        clearTimeout(window.keepRecoderAliveTimer);
      }
      window.keepRecoderAliveTimer = setTimeout(() => {
        this.keepRecoderAlive(url, args);
      }, 30 * 1000);
    },
    record_destroy() {
      if (this.recorderTimer) {
        clearInterval(this.recorderTimer);
      }
      if (window.keepRecoderAliveTimer) {
        clearTimeout(window.keepRecoderAliveTimer);
      }
      try {
        this.recoderVideo ? this.recoderVideo.pause() : "";
        this.recoderVideo ? this.recoderVideo.unload() : "";
        this.recoderVideo ? this.recoderVideo.detachMediaElement() : "";
        //http://localhost:18000/api/v1/devices/stopchannelstream?stream_type=playback&device=1&channel=1&url=%2Fflv%2Fhls%2Fstream_localhost_33_ch0001_04010000823000000_202195125727_202195131540.flv
        let getUrl = `/api/v1/devices/stopchannelstream?stream_type=playback&device=${this.deviceId}&channel=${this.iChannelId}&url=${this.recorderUrl}&token=${this.token}`;
        $.ajax({
          url: getUrl,
          success: (res) => {
            console.log(res, "res");
          },
        });
      } catch (err) {
        console.error(err);
      }
    },
    convertDoubleNum(val) {
      if (val < 10) {
        return "0" + val;
      } else {
        return "" + val;
      }
    },
    formatTooltip(val) {
      let curTS = (val / 100) * 600 * 1000;
      let minuteStr = Math.floor((curTS % (3600 * 1000)) / (60 * 1000));
      let secondStr = Math.floor((curTS % (60 * 1000)) / 1000);
      return (
        (minuteStr < 10 ? "0" + minuteStr : minuteStr) +
        ":" +
        (secondStr < 10 ? "0" + secondStr : secondStr)
      );
    },
  },
  mounted() {},
  unmounted() {
    this.record_destroy();
  },
};
</script>

<style lang="scss">
.recoder-bar {
  width: 1414px;
  position: absolute;
  bottom: -10px;
  left: -95%;
  .block {
    z-index: 99;
    position: absolute;
    left: 0px;
    transform-origin: left top;
  }
  .el-slider__runway {
    background: none !important;
    margin: 0px !important;
  }
  .el-slider__bar {
    background: darkorange !important;
  }
}
</style>
<style lang="scss" scoped="scoped">
.nvr-box {
  position: relative;
  // background-color: #000;
  // background-color: #15244D;
  width: 500px;
  .close-box {
    top: 6px;
    right: 6px;
  }
  .nvr-back-box {
    position: absolute;
    top: 6px;
    right: 135px;
    z-index: 1;
    cursor: pointer;
    &:hover {
      background-image: url("./img/back_active.png");
    }
  }
  .nvr-player {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    position: relative;
    .player_title {
      width: 100%;
      background: #000;
      position: absolute;
      top: 0px;
      left: 0;
      font-size: 26px;
      line-height: 50px;
      padding-left: 10px;
    }
    #divPlugin {
      position: relative;
      z-index: 1;
      > video {
        width: 100%;
        height: 100%;
        z-index: 100;
      }
    }
    .player_setting {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 90px;
      background: rgba(0, 0, 0, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 100000;
      &:before {
        content: "";
        position: absolute;
        bottom: 0;
      }
      .player_left {
        display: flex;
        align-items: center;
        .player_left_inner {
          display: flex;
        }
        .icon_play {
          width: 40px;
          height: 40px;
          margin: 0 25px 0 35px;
          background-image: url("./img/icon_pause.png");
          background-size: 100% 100%;
          cursor: pointer;
        }
        .icon_pause {
          background-image: url("./img/icon_play.png");
        }

        .player_time {
          font-size: 25px;
        }
      }
    }
    .player_right {
      display: flex;
      height: 80px;
      .speed_box {
        ul {
          display: flex;
          position: relative;
          margin-left: 15px;
          li {
            margin-top: 20px;
            width: 76px;
            height: 40px;
            border: 1px solid rgba(62, 147, 255, 0.8);
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.23) 0%,
              rgba(19, 82, 162, 0.6) 100%
            );
            opacity: 1;
            border-radius: 4px;
            margin-right: 17px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
      .player_SE {
        display: flex;
        .chooseTime {
          display: flex;
          align-items: center;
          margin-right: 20px;
          label {
            font-size: 20px;
          }
          .chooseTimeBg {
            width: 300px;
            height: 50px;
            background: rgba(89, 91, 95, 0.56);
            opacity: 1;
            border-radius: 6px;
            input {
              width: 100%;
              height: 100%;
              font-size: 24px;
              padding-left: 10px;
            }
          }
        }
        .back_confirm {
          font-size: 26px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
      .player_live_back {
        margin-right: 60px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .icon_live_back {
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-right: 10px;
          margin-top: 8px;
          background-image: url("./img/icon_replay_default.png");
          background-size: 100% 100%;
        }
        span {
          font-size: 28px;
        }
      }
      .player_speed {
        display: flex;
        align-items: center;
        margin-right: 50px;
        label {
          font-size: 26px;
        }
      }
    }

    .drag-point {
      position: absolute;
      left: 0px;
      top: -5px;
      width: 20px;
      height: 20px;
      border-radius: 10px;
    }
    .recoder-bar {
      position: relative;
      height: 10px;
      background: #666;
    }
    .recoders {
      position: absolute;
      height: 5px;
      background: #fff;
      border: 1px solid #ccc;
    }
    .hour-item {
      flex: 1;
      text-align: center;
      background: #000;
      color: #fff;
      border-right: 1px solid #000;
    }
  }
}
</style>
<style type="text/css" lang="scss">
.hour-bar {
  display: flex;
  width: 1414px;
  position: absolute;
  bottom: 0;
  left: -95%;
}
.nvr-player {
  .chooseTimeBg {
    .el-date-editor {
      width: 100%;
      height: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      .el-input__inner {
        background: transparent;
        border: 0;
        font-size: 24px;
        color: #fff;
      }
      .el-input__icon,
      .el-input__prefix {
        display: none;
      }
    }
  }
}
</style>
<style type="text/css" scoped>
/*用于定位海康视频时间框位置*/
.video_date_class {
  top: 45% !important;
  left: 73% !important;
}
/*不能选择项*/
.video_date_class .el-date-table td.disabled div {
  background-color: #000;
}
.video_date_class .el-date-table td span {
  border-radius: initial;
}
.video_date_class .el-picker-panel__footer .el-button {
  background: #409eff;
  color: #fff;
}
</style>
